const skillList = [
    {
        title: "Deep Learning / NLP",
        contents: [
            "Transformer",
            "Agent",
            "LLM",
            "LangChain",
            "RAG",
            "PyTorch"
        ]
    },
    {
        title: "Data Processing",
        contents: [
            "Apache Spark",
            "PySpark",
            "Pandas",
            "NumPy",
            "Synthetic Data Generation"
        ]
    },
    {
        title: "Fullstack / DevOps",
        contents: [
            "React",
            "Ruby on Rails",
            "Docker",
            "Kubernetes",
            "GCP / AWS"
        ]
    },
    {
        title: "Languages",
        contents: ["Python", "Scala", "C++", "C#", "Kotlin", "JavaScript"]
    }
]

export default skillList
